import Vue from 'vue'
import VueRouter from 'vue-router'

import Beranda from '../views/Beranda'
import KataPengantar from '../views/KataPengantar'
import PetunjukPenggunaan from '../views/PetunjukPenggunaan'
import DaftarPustaka from '../views/DaftarPustaka'
import Pendahuluan from '../views/Pendahuluan'
import Materi1 from '../views/Materi1'
import Materi2 from '../views/Materi2'
import Glosarium from '../views/Glosarium'
import Evaluasi1 from '../views/Evaluasi1'
import Evaluasi2 from '../views/Evaluasi2'
import EvaluasiUser from '../views/EvaluasiUser'
import TentangPenulis from '../views/TentangPenulis'

import Auth from '../views/Auth'
import Login from '../views/auth/Login'
import Register from '../views/auth/Register'
import GantiPassword from '../views/GantiPassword'
import LupaPassword from '../views/auth/LupaPassword'

// import Landing from '../views/Landing'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login
      },
      {
        path: 'register',
        name: 'register',
        component: Register
      },
      {
        path: 'lupa-password',
        name: 'lupa-password',
        component: LupaPassword
      }
    ]
  },
  {
    path: '/evaluasi/:halaman',
    component: EvaluasiUser,
    name: 'evaluasi-user',
    meta: {
      requiresAuth: true,
      doEvaluasi: true
    }
  },
  {
    path: '',
    component: Beranda,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/kata-pengantar',
        alias: '',
        name: 'kata-pengantar',
        component: KataPengantar,
      },
      {
        path: '/petunjuk-penggunaan',
        name: 'petunjuk-penggunaan',
        component: PetunjukPenggunaan,
      },
      {
        path: '/daftar-pustaka',
        name: 'daftar-pustaka',
        component: DaftarPustaka,
      },
      {
        path: '/pendahuluan/:id',
        name: 'pendahuluan',
        component: Pendahuluan
      },
      {
        path: '/materi1/:id',
        name: 'materi1',
        component: Materi1
      },
      {
        path: '/materi2/:id',
        name: 'materi2',
        component: Materi2
      },
      {
        path: '/glosarium',
        name: 'glosarium',
        component: Glosarium
      },
      {
        path: '/evaluasi1',
        name: 'evaluasi1',
        component: Evaluasi1
      },
      {
        path: '/evaluasi2',
        name: 'evaluasi2',
        component: Evaluasi2
      },
      {
        path: '/ganti-password',
        name: 'ganti-password',
        component: GantiPassword
      },
      {
        path: '/tentang-penulis',
        name: 'tentang-penulis',
        component: TentangPenulis
      }
    ]
  },
  // {
  //   path: '',
  //   component: Landing,
  //   name: 'landing'
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
